
        var result = require("!!../../../../../node_modules/css-loader/index.js!./belpex-statistics.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/belpex/belpex-statistics/belpex-statistics.component.css
// module id = 768
// module chunks = 0